import $ from 'jquery';

/**
 * 外部ファイルに記載されたHTMLを読み込むクラス
 */
export default class EFOcats_import_html {
  /**
   * 外部ファイルから読み出しをして、sectionのidごとに配列に格納
   * @param html
   */
  static load(html) {
    const elem = $(html);

    if (!EFOcats_import_html.items) EFOcats_import_html.items = {};

    elem.find('section').each((index, element) => {
      EFOcats_import_html.items[$(element).attr('id')] = $(element).html();
    });
  }

  /**
   * キーに合致するものを配列から取得し、変数の置換をした上で返す
   * @param {*} key
   * @param {*} parameter_array
   * @param {*} attr_array
   */
  static getValue(key, parameter_array, attr_array) {
    if (!EFOcats_import_html.items[key]) {
      return '';
    }

    let temp = EFOcats_import_html.items[key].toString();

    if (parameter_array) {
      Object.keys(parameter_array).forEach(param_key => {
        const param_val = parameter_array[param_key];

        // テンプレート内の変数を置換
        const regexp = new RegExp(`\\$\\{\\s*${param_key}\\s*\\}`, 'g');
        temp = temp.replace(regexp, param_val);
      });
    }

    // 未置換の変数を除去
    const regexp = new RegExp('\\$\\{\\s*.*\\s*\\}', 'g');
    temp = temp.replace(regexp, '');

    // 入力部品に属性を設定
    if (attr_array) {
      const elements = $(temp);
      Object.keys(attr_array).forEach(attr_key => {
        const val = attr_array[attr_key];
        elements.find('input,select,textarea').attr(attr_key, val);
      });
    }

    return temp;
  }
}
